import { Action, Reducer, Dispatch } from 'redux';
import { CoreInstanceSettingsMergePersonsAtImport, CoreInstanceSettingsPurgeAfterDays, CoreReservedValuesImportPreview } from '../models/CoreInstanceSettings';
import InstanceClient from '../services/InstanceClient';
import StatusCode from '../util/StatusCode';
import { EmptyRequestState, RequestState } from '../models/RequestState';

export enum InstanceConfigActionType {
    GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT = 'GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT',
    UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT = 'UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT',
    GET_INSTANCESETTINGS_PURGEAFTERDAYS = 'GET_INSTANCESETTINGS_PURGEAFTERDAYS',
    UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS = 'UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS',
    GET_RESERVEDVALUES_COUNT = 'GET_RESERVEDVALUES_COUNT',
    PREVIEW_RESERVEDVALUES_UPLOAD = 'PREVIEW_RESERVEDVALUES_UPLOAD',
    UPLOAD_RESERVEDVALUES = 'UPLOAD_RESERVEDVALUES',
    DOWNLOAD_RESERVEDVALUES = 'DOWNLOAD_RESERVEDVALUES',
}

export interface InstanceConfigState {
    mergePersonsAtImport: RequestState<CoreInstanceSettingsMergePersonsAtImport>
    updateMergePersonsAtImport: EmptyRequestState
    purgeAfterDays: RequestState<CoreInstanceSettingsPurgeAfterDays>
    updatePurgeAfterDays: EmptyRequestState
    updateStatus: EmptyRequestState
    reservedValuesCount: RequestState<number>
    reservedValuesUploadPreview: RequestState<CoreReservedValuesImportPreview>
    reservedValuesUpload: RequestState<CoreReservedValuesImportPreview>
    reservedValuesDownload: EmptyRequestState
}

interface GetInstanceSettings_MergePersonsAtImport extends Action<InstanceConfigActionType.GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT> {
    mergePersonsAtImport: RequestState<CoreInstanceSettingsMergePersonsAtImport>
}

interface UpdateInstanceSettings_MergePersonsAtImport extends Action<InstanceConfigActionType.UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT> {
    updateMergePersonsAtImport: EmptyRequestState
}

interface GetInstanceSettings_PurgeAfterDays extends Action<InstanceConfigActionType.GET_INSTANCESETTINGS_PURGEAFTERDAYS> {
    purgeAfterDays: RequestState<CoreInstanceSettingsPurgeAfterDays>
}
interface UpdateInstanceSettings_PurgeAfterDays extends Action<InstanceConfigActionType.UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS> {
    updatePurgeAfterDays: EmptyRequestState
}

interface GetReservedValuesCountAction extends Action<InstanceConfigActionType.GET_RESERVEDVALUES_COUNT> {
    reservedValuesCount: RequestState<number>
}

interface PreviewReservedValuesUploadAction extends Action<InstanceConfigActionType.PREVIEW_RESERVEDVALUES_UPLOAD> {
    reservedValuesUploadPreview: RequestState<CoreReservedValuesImportPreview>
}

interface UploadReservedValuesAction extends Action<InstanceConfigActionType.UPLOAD_RESERVEDVALUES> {
    reservedValuesUpload: RequestState<CoreReservedValuesImportPreview>
}

interface DownloadReservedValuesAction extends Action<InstanceConfigActionType.DOWNLOAD_RESERVEDVALUES> {
    reservedValuesDownload: EmptyRequestState
}

type InstanceConfigAction =
    GetReservedValuesCountAction
    | PreviewReservedValuesUploadAction
    | UploadReservedValuesAction
    | DownloadReservedValuesAction
    | GetInstanceSettings_MergePersonsAtImport
    | UpdateInstanceSettings_MergePersonsAtImport
    | GetInstanceSettings_PurgeAfterDays
    | UpdateInstanceSettings_PurgeAfterDays;


const initialState: InstanceConfigState = {
    mergePersonsAtImport: { code: StatusCode.NONE },
    updateMergePersonsAtImport: { code: StatusCode.NONE },
    purgeAfterDays: { code: StatusCode.NONE },
    updatePurgeAfterDays: { code: StatusCode.NONE },
    updateStatus: { code: StatusCode.NONE },
    reservedValuesCount: { code: StatusCode.NONE },
    reservedValuesUploadPreview: { code: StatusCode.NONE },
    reservedValuesUpload: { code: StatusCode.NONE },
    reservedValuesDownload: { code: StatusCode.NONE }
};

export const GetInstanceSettingsMergePersonsAtImport = () => (dispatch: Dispatch<GetInstanceSettings_MergePersonsAtImport>) => {
    dispatch({
        type: InstanceConfigActionType.GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
        mergePersonsAtImport: { code: StatusCode.PENDING },
    })
    const url = '/api/core/instanceSettings/mergePersonsAtImport';
    InstanceClient.get<CoreInstanceSettingsMergePersonsAtImport>(url)
        .then(res =>
            dispatch({
                type: InstanceConfigActionType.GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
                mergePersonsAtImport: { code: StatusCode.COMPLETE, data: res.data },
            }))
        .catch(error =>
            dispatch({
                type: InstanceConfigActionType.GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
                mergePersonsAtImport: { code: StatusCode.ERROR, error: error },
            }))
};

export const UpdateInstanceSettingsMergePersonsAtImport = (settings: CoreInstanceSettingsMergePersonsAtImport) => (dispatch: Dispatch<UpdateInstanceSettings_MergePersonsAtImport | GetInstanceSettings_MergePersonsAtImport>) => {
    dispatch({
        type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
        updateMergePersonsAtImport: { code: StatusCode.PENDING },
    })
    return InstanceClient.put<CoreInstanceSettingsMergePersonsAtImport, CoreInstanceSettingsMergePersonsAtImport>(`api/core/instanceSettings/mergePersonsAtImport`, settings)
        .then(res => {
            dispatch({
                type: InstanceConfigActionType.GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
                mergePersonsAtImport: { code: StatusCode.COMPLETE, data: res.data },
            });
            dispatch({
                type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
                updateMergePersonsAtImport: { code: StatusCode.COMPLETE }
            });
        })
        .catch(error => {
            dispatch({
                type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
                updateMergePersonsAtImport: { code: StatusCode.ERROR, error }
            })
        });
};

export const ClearUpdateInstanceSettingsMergePersonsAtImport = () => (dispatch: Dispatch<UpdateInstanceSettings_MergePersonsAtImport>) => {
    dispatch({
        type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT,
        updateMergePersonsAtImport: { code: StatusCode.NONE },
    });
}

export const GetInstanceSettingsPergeAfterDays = () => (dispatch: Dispatch<GetInstanceSettings_PurgeAfterDays>) => {
    dispatch({
        type: InstanceConfigActionType.GET_INSTANCESETTINGS_PURGEAFTERDAYS,
        purgeAfterDays: { code: StatusCode.PENDING },
    });
    const url = '/api/core/instanceSettings/purgeAfterDays';
    InstanceClient.get<CoreInstanceSettingsPurgeAfterDays>(url)
        .then(res =>
            dispatch({
                type: InstanceConfigActionType.GET_INSTANCESETTINGS_PURGEAFTERDAYS,
                purgeAfterDays: { code: StatusCode.COMPLETE, data: res.data },
            }))
        .catch(error =>
            dispatch({
                type: InstanceConfigActionType.GET_INSTANCESETTINGS_PURGEAFTERDAYS,
                purgeAfterDays: { code: StatusCode.ERROR, error: error },
            })
        )
};

export const UpdateInstanceSettingsPurgeAfterDays = (settings: CoreInstanceSettingsPurgeAfterDays) => (dispatch: Dispatch<UpdateInstanceSettings_PurgeAfterDays | GetInstanceSettings_PurgeAfterDays>) => {
    dispatch({
        type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS,
        updatePurgeAfterDays: { code: StatusCode.PENDING },
    })
    return InstanceClient.put<CoreInstanceSettingsPurgeAfterDays, CoreInstanceSettingsPurgeAfterDays>(`api/core/instanceSettings/purgeAfterDays`, settings)
        .then(res => {
            dispatch({
                type: InstanceConfigActionType.GET_INSTANCESETTINGS_PURGEAFTERDAYS,
                purgeAfterDays: { code: StatusCode.COMPLETE, data: res.data },
            });
            dispatch({
                type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS,
                updatePurgeAfterDays: { code: StatusCode.COMPLETE }
            });
        })
        .catch(error => {
            dispatch({
                type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS,
                updatePurgeAfterDays: { code: StatusCode.ERROR, error }
            })
        });
};

export const ClearUpdateInstanceSettingsPurgeAfterDays = () => (dispatch: Dispatch<UpdateInstanceSettings_PurgeAfterDays>) => {
    dispatch({
        type: InstanceConfigActionType.UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS,
        updatePurgeAfterDays: { code: StatusCode.NONE },
    })
}

export const GetReservedValuesCount = () => (dispatch: Dispatch<GetReservedValuesCountAction>) => {
    dispatch({
        type: InstanceConfigActionType.GET_RESERVEDVALUES_COUNT,
        reservedValuesCount: { code: StatusCode.PENDING }
    });

    return InstanceClient.get<number>(`api/core/instanceSettings/reservedValuesCount`)
        .then(res => dispatch({
            type: InstanceConfigActionType.GET_RESERVEDVALUES_COUNT,
            reservedValuesCount: { code: StatusCode.COMPLETE, data: res.data }
        }))
        .catch(error => dispatch({
            type: InstanceConfigActionType.GET_RESERVEDVALUES_COUNT,
            reservedValuesCount: { code: StatusCode.ERROR, error }
        }));
}

export const previewReservedValuesUpload = (file: File) => (dispatch: Dispatch<PreviewReservedValuesUploadAction>) => {
    const formData = new FormData();
    formData.append('file', file);

    dispatch({
        type: InstanceConfigActionType.PREVIEW_RESERVEDVALUES_UPLOAD,
        reservedValuesUploadPreview: { code: StatusCode.PENDING }
    });

    return InstanceClient.post<CoreReservedValuesImportPreview, FormData>(`api/core/instanceSettings/reservedValues/preview`, formData)
        .then(res => dispatch({
            type: InstanceConfigActionType.PREVIEW_RESERVEDVALUES_UPLOAD,
            reservedValuesUploadPreview: { code: StatusCode.COMPLETE, data: res.data }
        }))
        .catch(error => dispatch({
            type: InstanceConfigActionType.PREVIEW_RESERVEDVALUES_UPLOAD,
            reservedValuesUploadPreview: { code: StatusCode.ERROR, error }
        }));
}

export const ClearPreviewReservedValuesUpload = () => (dispatch: Dispatch<PreviewReservedValuesUploadAction>) => {
    dispatch({
        type: InstanceConfigActionType.PREVIEW_RESERVEDVALUES_UPLOAD,
        reservedValuesUploadPreview: { code: StatusCode.NONE }
    });
}

export const uploadReservedValues = (file: File) => (dispatch: Dispatch<UploadReservedValuesAction>) => {
    const formData = new FormData();
    formData.append('file', file);

    dispatch({
        type: InstanceConfigActionType.UPLOAD_RESERVEDVALUES,
        reservedValuesUpload: { code: StatusCode.PENDING }
    });

    return InstanceClient.post<CoreReservedValuesImportPreview, FormData>(`api/core/instanceSettings/reservedValues`, formData)
        .then(res => dispatch({
            type: InstanceConfigActionType.UPLOAD_RESERVEDVALUES,
            reservedValuesUpload: { code: StatusCode.COMPLETE, data: res.data }
        }))
        .catch(error => dispatch({
            type: InstanceConfigActionType.UPLOAD_RESERVEDVALUES,
            reservedValuesUpload: { code: StatusCode.ERROR, error }
        }));
}

export const ClearUploadReservedValues = () => (dispatch: Dispatch<UploadReservedValuesAction>) => {
    dispatch({
        type: InstanceConfigActionType.UPLOAD_RESERVEDVALUES,
        reservedValuesUpload: { code: StatusCode.NONE }
    });
}

export const downloadReservedValues = () => (dispatch: Dispatch<DownloadReservedValuesAction>) => {
    dispatch({
        type: InstanceConfigActionType.DOWNLOAD_RESERVEDVALUES,
        reservedValuesDownload: { code: StatusCode.PENDING }
    });

    return InstanceClient.download(`/api/core/instanceSettings/reservedValues`, 'reserved-values.csv')
        .then(() => dispatch({
            type: InstanceConfigActionType.DOWNLOAD_RESERVEDVALUES,
            reservedValuesDownload: { code: StatusCode.COMPLETE }
        }))
        .catch(error => dispatch({
            type: InstanceConfigActionType.DOWNLOAD_RESERVEDVALUES,
            reservedValuesDownload: { code: StatusCode.ERROR, error }
        }));
}

export const reducer: Reducer<InstanceConfigState, InstanceConfigAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case InstanceConfigActionType.GET_INSTANCESETTINGS_MERGEPERSONSATIMPORT:
            return {
                ...state,
                mergePersonsAtImport: action.mergePersonsAtImport
            }
        case InstanceConfigActionType.UPDATE_INSTANCESETTINGS_MERGEPERSONSATIMPORT:
            return {
                ...state,
                updateMergePersonsAtImport: action.updateMergePersonsAtImport
            };
        case InstanceConfigActionType.GET_INSTANCESETTINGS_PURGEAFTERDAYS:
            return {
                ...state,
                purgeAfterDays: action.purgeAfterDays
            };
        case InstanceConfigActionType.UPDATE_INSTANCESETTINGS_PURGEAFTERDAYS:
            return {
                ...state,
                updatePurgeAfterDays: action.updatePurgeAfterDays
            };
        case InstanceConfigActionType.GET_RESERVEDVALUES_COUNT:
            return {
                ...state,
                reservedValuesCount: action.reservedValuesCount,
            }
        case InstanceConfigActionType.PREVIEW_RESERVEDVALUES_UPLOAD:
            return {
                ...state,
                reservedValuesUploadPreview: action.reservedValuesUploadPreview,
            }
        case InstanceConfigActionType.UPLOAD_RESERVEDVALUES:
            return {
                ...state,
                reservedValuesUpload: action.reservedValuesUpload,
            }
        case InstanceConfigActionType.DOWNLOAD_RESERVEDVALUES:
            return {
                ...state,
                reservedValuesDownload: action.reservedValuesDownload,
            }
        default:
            return state;
    }
}
